/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_List_Filter_Only_AvailableInputs */

const vi_product_lot_list_filter_only_available = /** @type {(inputs: Product_Lot_List_Filter_Only_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ còn hàng`)
};

/**

* @param {Product_Lot_List_Filter_Only_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_list_filter_only_available = /** @type {((inputs?: Product_Lot_List_Filter_Only_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_List_Filter_Only_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_list_filter_only_available(inputs)
});